export default __webpack_public_path__ + "static/media/Ballroll_00365.a5b5dce9.png";